module.exports = {"421281001":"蒲圻街道","421281002":"赤马港街道","421281003":"陆水湖街道","421281100":"新店镇","421281101":"赵李桥镇","421281102":"茶庵岭镇","421281103":"车埠镇","421281104":"赤壁镇","421281105":"柳山湖镇","421281106":"神山镇","421281107":"中伙铺镇","421281108":"官塘驿镇","421281109":"黄盖湖镇","421281200":"余家桥乡","421281400":"蒲纺工业园","421281401":"官塘驿林场","421281402":"羊楼洞茶场","421281403":"沧湖开发区","421281404":"赤壁市经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421281.json
// module id = 1636
// module chunks = 0